import React from 'react';
const ChevronDownSVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='9'
      viewBox='0 0 16 9'
      fill='none'
      className={className}
      onClick={onClick}
    >
      <path
        d='M14.9229 1.07715C15.2262 1.38034 15.2261 1.89006 14.9229 2.19336L8.56055 8.55566C8.42069 8.69553 8.21294 8.78809 8.00195 8.78809C7.79097 8.78795 7.58394 8.69526 7.44434 8.55566L1.08203 2.19336C0.921157 2.03249 0.849697 1.84326 0.849609 1.63574C0.849609 1.42792 0.921054 1.23813 1.08203 1.07715C1.38525 0.773873 1.89497 0.773876 2.19824 1.07715L8.00293 6.88184L13.8066 1.07715C14.1099 0.77385 14.6196 0.773869 14.9229 1.07715Z'
        fill='black'
        stroke='#060606'
        strokeWidth='0.3'
      />
    </svg>
  );
};

export default ChevronDownSVG;
